import {
  home,
  participants,
  participant,
  userManagement,
  userManagementPeople,
  userManagementStudy,
  userManagementStudyParticipant,
  userManagementOrgStudy,
  userManagementOrgStudyParticipant,
  organization_details,
  peopleDetails_peopleFlow,
  peopleDetails_studyFlow
} from '../../constants/localUrls';
import { USER_MANAGEMENT, ORGANIZATION_DETAILS } from '../../const';

const ANY = '[a-zA-Z0-9 :.%|_]+';

const homePage = new RegExp('^/$|^$');
const activeStudiesPage = new RegExp(home() + '/*(?=/$|$)');
const studyPage = new RegExp(participants('[a-zA-Z0-9%|_]+(?=/$|$)'));
const participantPage = new RegExp(participant('[a-zA-Z0-9%|_]+(?=/$|$)'));
const userManagementPath = new RegExp(userManagement() + '/*(?=/$|$)');
const userManagementPeoplePath = new RegExp(userManagementPeople(ANY));
const userManagementStudyPath = new RegExp(userManagementStudy(ANY));
const userManagementStudyParticipantPath = new RegExp(userManagementStudyParticipant(ANY));
const userManagementOrgStudyPath = new RegExp(userManagementOrgStudy(ANY, ANY, ANY));
const userManagementOrgStudyParticipantPath = new RegExp(userManagementOrgStudyParticipant(ANY, ANY, ANY));
const organizationDetails = new RegExp(organization_details(ANY, `${ANY}(?=\/$|$)`));
const peopleDetailsPage_study = new RegExp(peopleDetails_studyFlow('[a-zA-Z0-9%|_]+', '[a-zA-Z0-9%|_]+(?=/$|$)'));
const peopleDetailsPage_people = new RegExp(peopleDetails_peopleFlow(ANY, ANY, ANY));

/**
 * @type {{study: [*], people: [*]}}
 *
 * fromState - when the breadcrumb paths are build the name of path E.g StudyName will be taken from the route state
 * hrefFn - when the breadcrumb items are build the hrefFn is called and it expects to find on the path state the necessaries values
 * @see TcBreadcrumbService.buildBreadcrumb. hrefFn is called there to get the value state from path
 *
 */
const flows = {
  study_a: [
    {
      index: 1,
      name: 'Studies',
      path: '',
      patterns: [homePage, activeStudiesPage],
      hrefFn: () => home()
    },
    {
      index: 2,
      name: ':study name',
      path: '',
      patterns: studyPage,
      fromState: 'studyName',
      hrefFn: (pathState) => participants(pathState.studyGid)
    },
    {
      index: 3,
      name: 'participant name',
      path: '',
      patterns: participantPage,
      fromState: 'participantName',
      hrefFn: (pathState) => participant(pathState.participantJourneyGid)
    }
  ],
  study_b: [
    {
      index: 1,
      name: 'Studies',
      path: '',
      patterns: [homePage, activeStudiesPage],
      hrefFn: () => home()
    },
    {
      index: 2,
      name: ':study name',
      path: '',
      patterns: studyPage,
      fromState: 'studyName',
      hrefFn: (pathState) => participants(pathState.studyGid)
    },
    {
      index: 3,
      name: ':user id',
      path: '',
      patterns: peopleDetailsPage_study,
      fromState: 'username',
      hrefFn: (pathState) => peopleDetails_studyFlow(pathState.studyGid, pathState.userId)
    }
  ],
  people_a: [
    {
      index: 1,
      name: USER_MANAGEMENT,
      path: '',
      patterns: userManagementPath,
      hrefFn: (pathState) => userManagement()
    },
    {
      index: 2,
      name: ':user email',
      path: '',
      patterns: userManagementPeoplePath,
      fromState: 'username',
      hrefFn: (pathState) => userManagementPeople(pathState.userId)
    }
  ],
  people_b: [
    {
      index: 1,
      name: USER_MANAGEMENT,
      path: '',
      patterns: userManagementPath,
      hrefFn: (pathState) => userManagement()
    },
    {
      index: 2,
      name: ORGANIZATION_DETAILS,
      path: '',
      patterns: organizationDetails,
      fromState: 'organizationName',
      hrefFn: (pathState) => organization_details(pathState.organizationId, pathState.organizationName)
    },
    {
      index: 3,
      name: ':user email',
      path: '',
      patterns: peopleDetailsPage_people,
      fromState: 'username',
      hrefFn: (pathState) =>
        peopleDetails_peopleFlow(pathState.userId, pathState.organizationId, pathState.organizationName)
    }
  ],
  people_c: [
    {
      index: 1,
      name: USER_MANAGEMENT,
      path: '',
      patterns: userManagementPath,
      hrefFn: (pathState) => userManagement()
    },
    {
      index: 2,
      name: 'study details',
      path: '',
      patterns: userManagementStudyPath,
      fromState: 'studyName',
      hrefFn: (pathState) => userManagementStudy(pathState.studyGid)
    },
    {
      index: 3,
      name: 'participant name',
      path: '',
      patterns: userManagementStudyParticipantPath,
      fromState: 'participantName',
      hrefFn: (pathState) => userManagementStudyParticipant(pathState.participantJourneyGid)
    }
  ],
  people_d: [
    {
      index: 1,
      name: USER_MANAGEMENT,
      path: '',
      patterns: userManagementPath,
      hrefFn: (pathState) => userManagement()
    },
    {
      index: 2,
      name: ORGANIZATION_DETAILS,
      path: '',
      patterns: organizationDetails,
      fromState: 'organizationName',
      hrefFn: (pathState) => organization_details(pathState.organizationId, pathState.organizationName)
    },
    {
      index: 3,
      name: 'study details',
      path: '',
      patterns: userManagementOrgStudyPath,
      fromState: 'studyName',
      hrefFn: (pathState) =>
        userManagementOrgStudy(pathState.organizationId, pathState.organizationName, pathState.studyGid)
    },
    {
      index: 4,
      name: 'participant name',
      path: '',
      patterns: userManagementOrgStudyParticipantPath,
      fromState: 'participantName',
      hrefFn: (pathState) =>
        userManagementOrgStudyParticipant(
          pathState.organizationId,
          pathState.organizationName,
          pathState.participantJourneyGid
        )
    }
  ]
};

export default flows;
